module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAYCAYAAAA20uedAAAAAXNSR0IArs4c6QAAAONJREFUKFN90U9Kw0AUBvDvS7c5Rf4segAFUUQRaSmKKFKMsT2H4Lr0ILa5TNd1ocZTvOxinnSaxjRNZlbD/N77ZnhDAJAXfwo6r1D6oKb41bmbfL9T4vAZwAIgN4XbpQrVCSUKPgGG1XlZosAX5SnIAfb+u6pdThmH2gLmiPLYgdzgQ4m15+ySKPe22Dsb3tawEU25sXWObDhsYC2aMggsQ7i24VUHmgldltg6oQtb7LkNz2rYnFB26nd/dnYSfADoH3w4saYcexEdJ9lDNSs2t8iRF7PnvEHhK5CiKGbu6mf5Bzt+V8ow7zSVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/p2.png
// module id = 23tB
// module chunks = 2